var _a;
import { SherpathAiTimeWindow } from 'reports/dp/models/ui.model';
export var DP_PATHS = {
    welcome: '/leadership/welcome',
    dashboard: '/leadership',
    cohorts: '/leadership/cohorts',
    thresholds: '/thresholds'
};
export var DP_DASHBOARD_TOGGLE_OPTIONS = [
    {
        key: 'institution',
        label: 'Institution',
        value: 'institution'
    },
    {
        key: 'campus',
        label: 'Campus',
        value: 'campus'
    },
    {
        key: 'program',
        label: 'Program',
        value: 'program'
    }
];
export var NULL_DISPLAY = '—';
export var HESI_THRESHOLD_SCORE = 850;
export var SIGNIFICANT_CHANGE_THRESHOLD = 9;
export var FIRST_PAGE_RESULTS = 4;
export var SHERPATH_AI_AVAILABLE_TIME_WINDOWS = [
    { key: SherpathAiTimeWindow.ThisWeek, label: 'this week' },
    { key: SherpathAiTimeWindow.LastWeek, label: 'last week' },
    { key: SherpathAiTimeWindow.ThisMonth, label: 'this month' },
    { key: SherpathAiTimeWindow.ThisSemester, label: 'this semester' }
];
export var DEFAULT_RESULTS_PER_PAGE = 6;
export var DEFAULT_PROGRAM_TAB = 'Summary';
export var DP_THRESHOLD_LEVEL_TEXT = {
    AT_RISK: 'Needs Further Preparation',
    BELOW_ACCEPTABLE: 'Below Acceptable',
    ACCEPTABLE: 'Acceptable',
    RECOMMENDED: 'Recommended'
};
export var DP_CHART_RANGES = {
    AT_RISK: "<750, ".concat(DP_THRESHOLD_LEVEL_TEXT.AT_RISK),
    BELOW_ACCEPTABLE: "750-849, ".concat(DP_THRESHOLD_LEVEL_TEXT.BELOW_ACCEPTABLE),
    ACCEPTABLE: "850-899, ".concat(DP_THRESHOLD_LEVEL_TEXT.ACCEPTABLE),
    RECOMMENDED: "\u2265900, ".concat(DP_THRESHOLD_LEVEL_TEXT.RECOMMENDED)
};
export var DP_PERFORMANCE_LEVELS = {
    AT_RISK: { backgroundColorClassName: 'u-custom-bg-color-old-brick', backgroundColorValue: '#95251b', value: 750 },
    BELOW_ACCEPTABLE: { backgroundColorClassName: 'u-custom-bg-color-orange-2', backgroundColorValue: '#de8329', value: 850 },
    ACCEPTABLE: { backgroundColorClassName: 'u-custom-bg-color-green-2', backgroundColorValue: '#77cd47', value: 900 },
    RECOMMENDED: { backgroundColorClassName: 'u-custom-bg-color-green-6', backgroundColorValue: '#157a0d' }
};
var customClassName = 'u-els-margin-right-1x';
export var DP_PERFORMANCE_LEGEND_CONFIG = [
    {
        content: DP_CHART_RANGES.AT_RISK,
        squareClassName: DP_PERFORMANCE_LEVELS.AT_RISK.backgroundColorClassName,
        customClassName: customClassName
    },
    {
        content: DP_CHART_RANGES.BELOW_ACCEPTABLE,
        squareClassName: DP_PERFORMANCE_LEVELS.BELOW_ACCEPTABLE.backgroundColorClassName,
        customClassName: customClassName
    },
    {
        content: DP_CHART_RANGES.ACCEPTABLE,
        squareClassName: DP_PERFORMANCE_LEVELS.ACCEPTABLE.backgroundColorClassName,
        customClassName: customClassName
    },
    {
        content: DP_CHART_RANGES.RECOMMENDED,
        squareClassName: DP_PERFORMANCE_LEVELS.RECOMMENDED.backgroundColorClassName,
        customClassName: customClassName
    }
];
export var DP_DASHBOARD_TABS = {
    INSTITUTION: 'Institution',
    CAMPUS: 'Campus',
    PROGRAM: 'Program'
};
export var THRESHOLD_LEVEL = {
    INSTITUTION: 'INSTITUTION',
    CAMPUS: 'CAMPUS',
    PROGRAM: 'PROGRAM'
};
/** Input display types for ThresholdRangeInput: below (max only), range (min–max), above (min only) */
export var THRESHOLD_RANGE_TYPE = {
    BELOW: 'below',
    RANGE: 'range',
    ABOVE: 'above'
};
/** Field keys for ThresholdScores — used by updateScore() and ThresholdRangeInputGroup */
export var SCORE_FIELDS = {
    NEEDS_PREPARATION_MAX: 'needsPreparationMax',
    BELOW_ACCEPTABLE_MIN: 'belowAcceptableMin',
    BELOW_ACCEPTABLE_MAX: 'belowAcceptableMax',
    ACCEPTABLE_MIN: 'acceptableMin',
    ACCEPTABLE_MAX: 'acceptableMax',
    RECOMMENDED_MIN: 'recommendedMin'
};
export var THRESHOLD_SCORE_RANGE = {
    needsPreparation: {
        colorClass: 'u-custom-bg-color-old-brick',
        label: DP_THRESHOLD_LEVEL_TEXT.AT_RISK
    },
    belowAcceptable: {
        colorClass: 'u-custom-bg-color-orange-2',
        label: DP_THRESHOLD_LEVEL_TEXT.BELOW_ACCEPTABLE
    },
    acceptable: {
        colorClass: 'u-custom-bg-color-green-2',
        label: DP_THRESHOLD_LEVEL_TEXT.ACCEPTABLE
    },
    recommended: {
        colorClass: 'u-custom-bg-color-green-3',
        label: DP_THRESHOLD_LEVEL_TEXT.RECOMMENDED
    }
};
export var DEFAULT_THRESHOLD = 1;
export var FAVORITE_CARD_TYPE = {
    NEED_ATTENTION_CARD: 'NEED_ATTENTION_CARD',
    PROGRAM_CARD: 'PROGRAM_CARD',
    WEAKNESS_CATEGORIES_CARD: 'WEAKNESS_CATEGORIES_CARD',
    PROGRAM_DETAIL_CATEGORY: 'PROGRAM_DETAIL_CATEGORY',
    CAMPUS_CARD: 'CAMPUS_CARD',
    CAMPUS_HESI_INCREASE_CARD: 'CAMPUS_HESI_INCREASE_CARD',
    CAMPUS_PROGRAM_CARD: 'CAMPUS_PROGRAM_CARD',
    STUDENTS_BELOW_THRESHOLD_CARD: 'STUDENTS_BELOW_THRESHOLD_CARD',
    HESI_SCORE_SUMMARY_CARD: 'HESI_SCORE_SUMMARY_CARD',
    MEAN_HESI_EXIT_SCORES_CARD: 'MEAN_HESI_EXIT_SCORES_CARD',
    PROGRAMS_ENGAGEMENT_CARD: 'PROGRAMS_ENGAGEMENT_CARD'
};
export var SUPPORTED_FAVORITE_CARD_TYPES = Object.values(FAVORITE_CARD_TYPE).filter(function (type) { return type !== FAVORITE_CARD_TYPE.PROGRAM_DETAIL_CATEGORY; });
export var FAVORITE_CARD_SIZE = {
    SMALL: 'SMALL', // 3 cards per row
    MEDIUM: 'MEDIUM', // 2 cards per row
    LARGE: 'LARGE' // 1 card per row
};
export var FAVORITE_CARD_SIZE_SPAN = (_a = {},
    _a[FAVORITE_CARD_SIZE.SMALL] = 2,
    _a[FAVORITE_CARD_SIZE.MEDIUM] = 3,
    _a[FAVORITE_CARD_SIZE.LARGE] = 6,
    _a);
export var THRESHOLDS_COMPONENT_KEY = 'HESI_SCORE_THRESHOLDS';
export var HOME_PINS_ORDER_COMPONENT_KEY = 'DP_HOME_PINS_ORDER';
export var THRESHOLDS_QUERY_KEY = function (ecrId) { return ['user-preferences', ecrId]; };
export var DEFAULT_THRESHOLDS = {
    needsPreparation: { maxScore: 749 },
    belowAcceptable: { minScore: 750, maxScore: 849 },
    acceptable: { minScore: 850, maxScore: 899 },
    recommended: { minScore: 900 }
};
export var DP_PAGE_NAMES = {
    LEADERSHIP_WELCOME: 'Leadership Welcome',
    INSTITUTION: 'Institution',
    CAMPUS: 'Campus',
    PROGRAM_SUMMARY: 'Program Summary',
    PROGRAM_DETAILS: 'Program Details',
    COHORT_LIST: 'Cohort List',
    CUSTOM_THRESHOLD: 'Custom Threshold'
};
export var CAMPUS_CARD_METRIC = {
    STUDENTS_BELOW_THRESHOLD: 'STUDENTS_BELOW_THRESHOLD',
    AVG_A2_SCORE: 'AVG_A2_SCORE',
    HESI_SCORE_CHANGE: 'HESI_SCORE_CHANGE',
    SHERPATH_INSTRUCTORS_ASSIGNING: 'SHERPATH_INSTRUCTORS_ASSIGNING',
    SHERPATH_STUDENTS_ENGAGING: 'SHERPATH_STUDENTS_ENGAGING',
    SHERPATH_AI_USAGE: 'SHERPATH_AI_USAGE'
};
export var PROGRAM_CARD_METRIC = {
    HESI_MEAN_SCORE: 'HESI_MEAN_SCORE',
    HESI_STUDENTS_BELOW_THRESHOLD: 'HESI_STUDENTS_BELOW_THRESHOLD',
    SHERPATH_ENGAGEMENT: 'SHERPATH_ENGAGEMENT',
    SHERPATH_EAQ_SELF_STUDY: 'SHERPATH_EAQ_SELF_STUDY',
    SHERPATH_PRESCRIPTION_FOR_SUCCESS: 'SHERPATH_PRESCRIPTION_FOR_SUCCESS',
    SHADOW_HEALTH_MOST_PRACTICED_SIMULATION: 'SHADOW_HEALTH_MOST_PRACTICED_SIMULATION',
    SHADOW_HEALTH_AVG_SIMULATIONS_ASSIGNED: 'SHADOW_HEALTH_AVG_SIMULATIONS_ASSIGNED'
};
export var HIDDEN_METRICS_COMPONENT_KEY_PREFIX = 'HIDDEN_METRICS';
export var PROGRAM_HIDDEN_METRICS_COMPONENT_KEY_PREFIX = 'PROGRAM_HIDDEN_METRICS';
export var DP_PRODUCT_NAME = 'dp';
export var SherpathCardId;
(function (SherpathCardId) {
    SherpathCardId["ENGAGEMENT"] = "engagement";
    SherpathCardId["EAQ_SELF_STUDY"] = "eaq-self-study";
    SherpathCardId["PRESCRIPTION_FOR_SUCCESS"] = "prescription-for-success";
})(SherpathCardId || (SherpathCardId = {}));
